import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import Checkbox from 'material-ui/Checkbox';
import { SelectableList, SocialNetworkIcon, ControlBar, Control, Spinner, Stars } from 'components';
import moment from 'moment';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import * as styles from './ConversationList.scss';
import FontIcon from 'material-ui/FontIcon';

var ConversationList = /*#__PURE__*/function (_Component) {
  _inherits(ConversationList, _Component);

  var _super = _createSuper(ConversationList);

  function ConversationList() {
    var _this;

    _classCallCheck(this, ConversationList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getConversationPlatform", function (c) {
      if (c.parentEntity && c.parentEntity.facebookId) {
        return 'facebook';
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "getConversationDateTime", function (c, type) {
      var messageTime;

      if (type === 'PAGE_POST') {
        messageTime = moment(c.Messages[0].details.created_time);
      } else if (type === 'USER_PROFILE') {
        messageTime = moment(c.Messages[0].details.timestamp);
      }

      var isCurrentDate = messageTime.isSame(new Date(), 'day');
      return isCurrentDate ? messageTime.format('h:mm A') : messageTime.format('M/D/YY');
    });

    _defineProperty(_assertThisInitialized(_this), "getPagePostAvatarImage", function (conversation) {
      var post = conversation ? conversation.parentEntity : null;
      var imageUrl = 'https://likeabucket.s3.amazonaws.com/user_upload/0/B1fQZu4bW.png'; // set baseline avatar image

      if (conversation && conversation.Messages && !!conversation.Messages.length && conversation.Messages[0].authorAvatarUrl) {
        imageUrl = conversation.Messages[0].authorAvatarUrl;
      } // excessive checking of json received - hopefully preventing errors


      if (post && post.details && post.details.attachments && post.details.attachments.data && !!post.details.attachments.data.length) {
        // has an image or video
        var data = post.details.attachments.data[0]; // again, crazy checking

        if (data.subattachments && data.subattachments.data && !!data.subattachments.data.length && data.subattachments.data[0].media && data.subattachments.data[0].media.image && data.subattachments.data[0].media.image.src) {
          // has multiple images
          imageUrl = data.subattachments.data[0].media.image.src;
        } else if (data.media && data.media.image && data.media.image.src) {
          imageUrl = data.media.image.src;
        }
      }

      return imageUrl;
    });

    _defineProperty(_assertThisInitialized(_this), "getPageReviewAvatarImage", function (c) {
      var imageUrl = c.parentEntity.details.reviewer.picture.url;
      imageUrl = 'http://bit.ly/2qZJfZ6';
      return imageUrl;
    });

    _defineProperty(_assertThisInitialized(_this), "parseConversations", function (conversations) {
      var parsedConversations = [];
      conversations.forEach(function (c) {
        var modelName = c.ObjectType.modelName;
        /*
          FACEBOOK
        */

        if (modelName === 'FacebookObject') {
          var type = c.parentEntity.facebookObjectType;

          if (type === 'PAGE_POST') {
            parsedConversations.push({
              primaryText: c.previewTitle ? c.previewTitle : c.Messages[0].authorName,
              secondaryText: c.previewSubtitle ? c.previewSubtitle : c.Messages[0].text,
              avatarImageUrl: _this.getPagePostAvatarImage(c),
              network: _this.getConversationPlatform(c),
              read: !c.Messages.some(function (m) {
                return m.isNew;
              }),
              dateTime: _this.getConversationDateTime(c, 'PAGE_POST')
            });
          } else if (type === 'USER_PROFILE') {
            var name = c.Messages[0].details.user ? "".concat(c.Messages[0].details.user.first_name, " ").concat(c.Messages[0].details.user.last_name) : 'Direct Message';
            var avatarUrl = c.Messages[0].details.user ? c.Messages[0].details.user.profile_pic : 'http://bit.ly/2qZJfZ6';
            parsedConversations.push({
              primaryText: name,
              secondaryText: c.Messages[0].text,
              avatarImageUrl: avatarUrl,
              network: _this.getConversationPlatform(c),
              read: !c.Messages.some(function (m) {
                return m.isNew;
              }),
              dateTime: _this.getConversationDateTime(c, 'USER_PROFILE'),
              networkSubType: 'messenger'
            });
          } else if (type === 'PAGE_RATING') {
            var parentReviewName = c.parentEntity.details.reviewer.name;
            var parentReviewText = c.parentEntity.details.review_text;
            parsedConversations.push({
              primaryText: c.previewTitle ? c.previewTitle : parentReviewName,
              secondaryText: c.previewSubtitle ? c.previewSubtitle : parentReviewText,
              avatarImageUrl: _this.getPageReviewAvatarImage(c),
              network: 'facebook',
              read: !c.Messages.some(function (m) {
                return m.isNew;
              }),
              dateTime: '',
              networkSubType: 'review',
              iconStyle: {
                position: 'relative',
                top: -7,
                left: 4,
                width: 27,
                height: 27
              }
            });
          }
        } else if (modelName === 'InstagramObject') {
          /*
          INSTAGRAM
          */
          parsedConversations.push({
            primaryText: c.previewTitle ? c.previewTitle : 'Instagram Comment',
            secondaryText: c.previewSubtitle ? c.previewSubtitle : 'New comment on Instagram',
            avatarImageUrl: c.parentEntity.details.user.profile_picture,
            network: 'instagram',
            read: !c.Messages.some(function (m) {
              return m.isNew;
            }),
            dateTime: '',
            iconStyle: {
              position: 'relative',
              top: -7,
              left: 4,
              width: 27,
              height: 27
            }
          });
        } else if (modelName === 'TwitterObject') {
          /*
          TWITTER
          */
          parsedConversations.push({
            primaryText: c.previewTitle ? c.previewTitle : 'Twitter Comment',
            secondaryText: c.previewSubtitle ? c.previewSubtitle : 'New reply on Twitter',
            avatarImageUrl: c.Messages[0].authorAvatarUrl,
            network: 'twitter',
            read: '',
            //! c.Messages.some(m => m.isNew),
            dateTime: '',
            iconStyle: {
              position: 'relative',
              top: -7,
              left: 4,
              width: 27,
              height: 27
            }
          });
        }
      });
      return parsedConversations;
    });

    _defineProperty(_assertThisInitialized(_this), "renderList", function (conversations) {
      if (conversations.length === 0) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-12",
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("h3", null, "Your ", _this.props.viewType === 0 ? 'Inbox' : 'Archive', " is empty."))), /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-12",
          style: {
            textAlign: 'center'
          }
        }, _this.props.viewType === 0 && /*#__PURE__*/React.createElement("p", {
          style: {
            padding: '1rem'
          }
        }, "Replies and messages on your social accounts will appear here."), _this.props.viewType === 1 && /*#__PURE__*/React.createElement("p", {
          style: {
            padding: '1rem'
          }
        }, "Archived Conversations will appear here."))));
      }

      var listItems = conversations.map(function (c) {
        var leftImg = function () {
          if (c.Subject) {
            if (c.Subject.hasOwnProperty('facebookId')) {
              if (c.Subject.facebookObjectType === 'PAGE_POST') {
                try {
                  return c.Subject.attachments[0].details.subattachments ? c.Subject.attachments[0].details.subattachments.data[0].media.image.src : c.Subject.attachments[0].details.media.image.src;
                } catch (e) {}
              }
            }
          }

          return null;
        }();

        return /*#__PURE__*/React.createElement(ListItem, {
          key: c.id,
          style: {
            borderBottom: '1px solid #dfdfdf'
          },
          value: c.id,
          leftAvatar: leftImg ? /*#__PURE__*/React.createElement(Avatar, {
            size: 45,
            src: leftImg
          }) : null,
          rightIcon: /*#__PURE__*/React.createElement(SocialNetworkIcon, {
            network: function () {
              if (c.Subject) {
                if (c.Subject.hasOwnProperty('facebookId')) {
                  return 'facebook';
                }
              }

              return 'unknown';
            }(),
            networkSubType: function () {
              if (c.Subject) {
                if (c.Subject.hasOwnProperty('facebookId')) {
                  switch (c.Subject.facebookObjectType) {
                    case 'PAGE_RATING':
                      return 'review';

                    case 'MESSENGER_MESSAGE':
                      return 'messenger';

                    default:
                      return false;
                  }
                }
              }

              return false;
            }(),
            style: {
              display: 'flex',
              height: 20,
              width: 20,
              top: 14
            },
            size: "mediumPlus",
            iconStyle: c.iconStyle
          }),
          primaryText: /*#__PURE__*/React.createElement("p", {
            className: styles.primaryText,
            style: c.read ? {
              opacity: 0.8
            } : {
              fontWeight: 'bold'
            }
          }, function () {
            if (c.Subject) {
              if (c.Subject.details.message) {
                return c.Subject.details.message;
              } else if (c.Subject.details.review_text) {
                return c.Subject.details.review_text;
              } else if (c.Subject.details.status_type === 'shared_story') {
                return /*#__PURE__*/React.createElement("i", null, "Shared a story");
              }
            }

            return /*#__PURE__*/React.createElement("i", null, "Empty message");
          }()),
          secondaryText: /*#__PURE__*/React.createElement("p", {
            className: styles.secondaryText,
            style: {}
          }, c.Subject ? "".concat(_.startCase(c.Subject.facebookObjectType.toLowerCase()), " \u2022 ").concat(moment(c.Subject.platformCreatedAt).format('lll')) : ''),
          secondaryTextLines: 1
        });
      });
      return /*#__PURE__*/React.createElement(SelectableList, {
        value: _this.props.selectedConversationId,
        style: {
          flex: '1 1 auto',
          padding: 0,
          paddingLeft: 50
        },
        onChange: _this.props.handleListChange
      }, listItems, _this.props.hasMore && _this.props.viewType === 0 && /*#__PURE__*/React.createElement(ListItem, {
        value: 'load_more',
        primaryText: /*#__PURE__*/React.createElement("p", {
          className: styles.primaryText,
          style: {
            fontWeight: 'bold'
          }
        }, _this.props.loadingConversations ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin"
        }) : 'Load More')
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCheckboxList", function (conversations) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.checkboxList
      }, conversations.map(function (c) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          key: c.id,
          checked: _this.props.selectedConversations && _this.props.selectedConversations["".concat(c.id)] === true,
          onCheck: function onCheck(e, isChecked) {
            _this.props.onConversationChecked(c.id, isChecked);
          },
          iconStyle: {
            marginTop: 13,
            marginLeft: 6
          },
          style: {
            borderBottom: '1px solid #dfdfdf',
            height: 75,
            margin: 0,
            width: '100%'
          }
        });
      }));
    });

    return _this;
  }

  _createClass(ConversationList, [{
    key: "render",
    value: function render() {
      var conversations = this.props.conversations;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.listWrap,
        id: "ConversationList"
      }, /*#__PURE__*/React.createElement("div", null, this.renderCheckboxList(conversations), this.renderList(conversations)));
    }
  }]);

  return ConversationList;
}(Component);

export { ConversationList as default };